import { Flex, Text } from "@chakra-ui/react"

export const UserDetailItemLabel = ({ children }: { children: React.ReactNode }) => {
  return <Flex sx={{ gap: 2, ml: -3 }}>{children}</Flex>
}

export const UserDetailItemValue = ({ children }: { children: React.ReactNode }) => {
  return <Text sx={{ gap: 2, fontWeight: 'medium' }}>{children}</Text>
}
